import React from 'react';

import image_base from '../resources/image/GrandeeHamanako2.jpg';
import GolfSearchTemplate from '../components/template/golfSearchTemplate';
import common from "../resources/js/common/common"
import { apiKeyCheck, golfLoginApi,ssoLogin,versionGetApi,golfReservationList,vacancyOverviewApi } from "../const/";
import { default as commonUtil } from "../common/commonUtil";
class GolfSearch extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 検索条件保存モーダル
            savedSearchCriteriaPopup: false,
            // カレンダーモーダル
            playDatePopup: false,
            // 開始時間モダール
            startTimePopup: false,
            // エリア・施設モーダル
            areaSelectionPopup: false,
            playDateFlg: false,
            popupDataList: [],
            golfReservationPopup : false,
            facilityCalendarPopup: false,
            courseId: "",
            facilityVacancyInfo: {
                facilityId: "",
                facilityName: "",
                facilityTel: "",
                vacancyDateList: []
            },
        };
    };

    render() {

        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            },
        }
        // 検索条件保存モーダル
        const onClickOpenSavedSearchCriteriaWindow = () => this.setState({ savedSearchCriteriaPopup: !this.state.savedSearchCriteriaPopup });

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(golfReservationList, { userId : loginId }, afterConfirmGolfReservation);
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // 予約情報取得後処理
        const afterConfirmGolfReservation = (res) => {
            console.log("予約情報取得レスポンス");
            console.log(res);
            if (res.data.resultCode !== 0) {

            } else {
                console.log("予約情報取得レスポンスBODY");
                console.log(res.data);
                this.setState(
                    {
                        popupDataList: res.data.Data,
                    }
                );
            }
        }

        
        // カレンダーモーダル
        const onClickOpenSelectDateWindow = (e) => {
            this.setState({ playDatePopup: !this.state.playDatePopup });
            let flg = false;
            if (e != undefined) {
                if (e.target.id == 'playDate') {
                    flg = true;
                }
                else if (e.target.id == 'playDate1') {
                    flg = false;
                }
                this.setState({ playDateFlg: flg });
            }

        }
        // 開始時間モダール
        const onClickOpenStartTimeWindow = () => this.setState({ startTimePopup: !this.state.startTimePopup });
        // エリア・施設モーダル
        const onClickOpenSelectAreaWindow = () => this.setState({ areaSelectionPopup: !this.state.areaSelectionPopup });

        // 施設カレンダーモーダル
        const onClickOpenFacilityCalendarWindow = (req, name, dispStartDate) => {
            this.setState(
                {
                    facilityCalendarPopup: true,
                    calendarStartDate: dispStartDate,
                    courseId: req.courseId[0] ? req.courseId[0] : "",
                    facilityCalendarFlg: true,
                    popupTitle: name ? name : ""
                }
            );
            console.log(req);
            // カレンダー検索用検索情報取得
            common.doPost(vacancyOverviewApi, req, afterGetVacancy);
        }

        const onClickCalendarMove = (req) => {
            console.log(req);
            // カレンダー検索用検索情報取得
            common.doPost(vacancyOverviewApi, req, afterGetVacancy);
        }

        const afterGetVacancy = (res) => {
            const data = res.data;
            console.log(data);
            if (data.facilities) {
                let shisetsuCd = "";
                let shisetsuName = "";
                let shisetsuTel = "";
                let facilityVacancyList = [];
                let startDate = commonUtil.getDateFromString(data.startDate,"-")
                let vacancyList = [];
                data.facilities.forEach((value, index) => {
                    if (index === 0) {
                        shisetsuCd = value.facilityId;
                        shisetsuName = value.facilityName;
                        // shisetsuTel = value.shisetsuTel;
                        value.vacancy.map((value,index2)=>{
                            let date = commonUtil.getDateFromString(data.startDate,"-")
                            date.setDate(startDate.getDate() + index2);
                            let obj = {
                                riyoDate:commonUtil.getStringFromDate(date, "yyyy-MM-dd"),
                                kushitsuMark:value
                            }
                            vacancyList.push(obj);
                        });
                    }
                })
                console.log(vacancyList);
                this.setState({
                    facilityVacancyInfo: {
                        facilityId: shisetsuCd,
                        facilityName: shisetsuName,
                        facilityTel: shisetsuTel,
                        vacancyDateList: vacancyList
                    }
                });
            }     
        }

        const onClickCloseFacilityCalendarWindow = () => { this.setState({ facilityCalendarPopup: false }); }

        
        return (
            <div style={style.base}>
                <GolfSearchTemplate
                    state={this.state}
                    onClickOpenSavedSearchCriteriaWindow={onClickOpenSavedSearchCriteriaWindow}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickOpenSelectDateWindow={onClickOpenSelectDateWindow}
                    onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                    onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow}
                    onClickCloseFacilityCalendarWindow={onClickCloseFacilityCalendarWindow}
                    onClickCalendarMove={onClickCalendarMove} />
            </div>
        )
    }
}

            // let res = {
            //     data:[
            //         {
            //             golfCourseID:"0012200027",
            //             golfCourseName:"グランディ浜名湖ゴルフクラブ",
            //             reservationNo:"1000-2131-4488-8413",
            //             playDate:"2022-03-21T00:00:00",
            //             ttbLoginUserID:"6",
            //             familyName:"グランディ",
            //             firstName:"複数",
            //             familyNameKana:"フクスウ",
            //             firstNameKana:"フクスウ",
            //             email:"yo-sasaki@skygroup.jp",
            //             zipCode:"",
            //             addressPref:"北海道",
            //             address1:"",
            //             address2:"",
            //             address3:"",
            //             phoneNumber:"",
            //             contactPhoneNumber:"09012345678",
            //             partyCount:1,
            //             headCount:2,
            //             usePoint:0,
            //             pointToGiven:0,
            //             ttbPlanID:830661,
            //             planName:"スタンダードプラン",
            //             price:0.0000,
            //             additionalFee2bFlag:0,
            //             additionalFee2b:0.0000,
            //             combination2bFlag:0,
            //             additionalFee3bFlag:0,
            //             additionalFee3b:0.0000,
            //             combination3bFlag:0,
            //             discountFee4bFlag:0,
            //             discountFee4b:0.0000,
            //             discountFee4bNotice:"",
            //             hotelPackFlag:0,
            //             lunchFlag:0,
            //             caddyFlag:0,
            //             drinkFlag:0,
            //             lessonFlag:0,
            //             openCompetitionFlag:0,
            //             breakfastFlag:0,
            //             oneCoinFlag:0,
            //             ladiesFlag:0,
            //             juniorFlag:0,
            //             throughPlayFlag:0,
            //             cartType:0,
            //             roundType:0,
            //             roundStyleClass:0,
            //             planType:0,
            //             reservedTime:"2022-03-18T13:12:42",
            //             canceledTime:"0001-01-01T00:00:00",
            //             remark:"",
            //             planRemark:"相互利用料金<br>\r\nセントクリークGC　　メンバー本人：○万円、同伴者：○万円\r\nメイプルポイントGC　メンバー本人：○万円、同伴者：○万円\r\nグランディGC　　　　メンバー本人：○万円、同伴者：○万円",
            //             cancelFeeDayUsual:0,
            //             cancelFeeTypeUsual:0,
            //             cancelFeeUsual:0.0000,
            //             cancelFeedayHoliday:0,
            //             cancelFeeTypeHoliday:0,
            //             cancelFeeHoliday:0.0000,
            //             reservationQualification:1,
            //             accampanyQualification:1,
            //             referralQualification:1,
            //             referralPrice:0.0000,
            //             priceVisitorAccompany:0.0000,
            //             reservationCompe:null,
            //             teeTimeList:[
            //                 {
            //                     playDate:"2022-03-21T00:00:00",
            //                     teeTime:"0721",
            //                     courseID:100038,
            //                     courseNo:2,
            //                     courseName:"IN",
            //                     playerCount:2,
            //                     playerList:[
            //                         {
            //                             playerName:"グランディ複数",
            //                             playerNameKana:"グランディフクスウ",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         },
            //                         {
            //                             playerName:"高田けんじ",
            //                             playerNameKana:"タカダケンジ",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         }
            //                     ],
            //                     planSetId:370697,
            //                     price:16650,
            //                     priceDecimal:16650.0000,
            //                     discount:0.0000,
            //                     referralPrice:0,
            //                     referralPriceDecimal:0.0000,
            //                     priceVisitorAccompany:0,
            //                     priceVisitorAccompanyDecimal:0.0000,
            //                     additionalFee2b:2000,
            //                     additionalFee2bDecimal:2000.0000,
            //                     additionalFee3b:1000,
            //                     additionalFee3bDecimal:1000.0000,
            //                     usageFeeType:1,
            //                     usageFee:0.0000,
            //                     usageFeeRate:0.000,
            //                     maxUsageFee:0.0000
            //                 }
            //             ],
            //             customerClassCode:0,
            //             isRequest:false,
            //             memberCode:"1000119000023115",
            //             reservationsDayInformationList:[
            //                 {
            //                     playDate:"2022-03-21T00:00:00",
            //                     remark:"",
            //                     ntgGeneralPurposeItem:
            //                         {
            //                             ResortTrustInfomation:
            //                                 {
            //                                     ownerMemberCode:"1000119000023115",
            //                                     hotelReservationNo:"0087500069",
            //                                     isDirectDebit:false
            //                                 }
            //                         }
            //                 }
            //             ]
            //         },
            //         {
            //             golfCourseID:"0012200027",
            //             golfCourseName:"グランディ浜名湖ゴルフクラブ",
            //             reservationNo:"1000-2131-4488-6630",
            //             playDate:"2022-03-21T00:00:00",
            //             ttbLoginUserID:"6",
            //             familyName:"検証",
            //             firstName:"お客様",
            //             familyNameKana:"オキャク",
            //             firstNameKana:"オキャク",
            //             email:"yo-sasaki@skygroup.jp",
            //             zipCode:"",
            //             addressPref:"北海道",
            //             address1:"",
            //             address2:"",
            //             address3:"",
            //             phoneNumber:"",
            //             contactPhoneNumber:"09012345678",
            //             partyCount:1,
            //             headCount:2,
            //             usePoint:0,
            //             pointToGiven:0,
            //             ttbPlanID:830661,
            //             planName:"スタンダードプラン",
            //             price:0.0000,
            //             additionalFee2bFlag:0,
            //             additionalFee2b:0.0000,
            //             combination2bFlag:0,
            //             additionalFee3bFlag:0,
            //             additionalFee3b:0.0000,
            //             combination3bFlag:0,
            //             discountFee4bFlag:0,
            //             discountFee4b:0.0000,
            //             discountFee4bNotice:"",
            //             hotelPackFlag:0,
            //             lunchFlag:0,
            //             caddyFlag:0,
            //             drinkFlag:0,
            //             lessonFlag:0,
            //             openCompetitionFlag:0,
            //             breakfastFlag:0,
            //             oneCoinFlag:0,
            //             ladiesFlag:0,
            //             juniorFlag:0,
            //             throughPlayFlag:0,
            //             cartType:0,
            //             roundType:0,
            //             roundStyleClass:0,
            //             planType:0,
            //             reservedTime:"2022-03-18T14:06:28",
            //             canceledTime:"0001-01-01T00:00:00",
            //             remark:"ゴルフ用の備考入力",
            //             planRemark:"相互利用 料金<br>\r\nセントクリークGC　　メンバー本人：○万円、同伴者：○万円\r\nメイプルポイントGC　メンバー本人：○万円、同伴者：○万円\r\nグランディGC　　　　メンバー本人：○万円、同伴者：○万円",
            //             cancelFeeDayUsual:0,
            //             cancelFeeTypeUsual:0,
            //             cancelFeeUsual:0.0000,
            //             cancelFeedayHoliday:0,
            //             cancelFeeTypeHoliday:0,
            //             cancelFeeHoliday:0.0000,
            //             reservationQualification:1,
            //             accampanyQualification:1,
            //             referralQualification:1,
            //             referralPrice:0.0000,
            //             priceVisitorAccompany:0.0000,
            //             reservationCompe:null,
            //             teeTimeList:[
            //                 {
            //                     playDate:"2022-03-21T00:00:00",
            //                     teeTime:"0728",
            //                     courseID:100038,
            //                     courseNo:2,
            //                     courseName:"IN",
            //                     playerCount:2,
            //                     playerList:[
            //                         {
            //                             playerName:"検証お客様",
            //                             playerNameKana:"ケンショウオキャク",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         },
            //                         {
            //                             playerName:"お客様その二",
            //                             playerNameKana:"オキャクサマソノニ",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         }
            //                     ],
            //                     planSetId:370697,
            //                     price:16650,
            //                     priceDecimal:16650.0000,
            //                     discount:0.0000,
            //                     referralPrice:0,
            //                     referralPriceDecimal:0.0000,
            //                     priceVisitorAccompany:0,
            //                     priceVisitorAccompanyDecimal:0.0000,
            //                     additionalFee2b:2000,
            //                     additionalFee2bDecimal:2000.0000,
            //                     additionalFee3b:1000,
            //                     additionalFee3bDecimal:1000.0000,
            //                     usageFeeType:1,
            //                     usageFee:0.0000,
            //                     usageFeeRate:0.000,
            //                     maxUsageFee:0.0000
            //                 },
            //                 {
            //                     playDate:"2022-03-21T00:00:00",
            //                     teeTime:"1728",
            //                     courseID:100038,
            //                     courseNo:1,
            //                     courseName:"OUT",
            //                     playerCount:3,
            //                     playerList:[
            //                         {
            //                             playerName:"検証お客様",
            //                             playerNameKana:"ケンショウオキャク",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         },
            //                         {
            //                             playerName:"お客様その二",
            //                             playerNameKana:"オキャクサマソノニ",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         },
            //                         {
            //                             playerName:"お客様さん",
            //                             playerNameKana:"オキャクサン",
            //                             genderType:0,
            //                             email:"",
            //                             webUserFlag:0,
            //                             webUserID:0,
            //                             memberCode:"",
            //                             usePoint:0,
            //                             zipCode:"",
            //                             addressPref:"",
            //                             address1:"",
            //                             address2:"",
            //                             address3:"",
            //                             phoneNumber:"",
            //                             contactPhoneNumber:"",
            //                             price:0,
            //                             reservationQualification:0,
            //                             soloEntryReservationNo:null,
            //                             isSoloEntryRepresent:false,
            //                             pointCardNumber:null
            //                         }
            //                     ],
            //                     planSetId:370697,
            //                     price:265555,
            //                     priceDecimal:265555.0000,
            //                     discount:0.0000,
            //                     referralPrice:0,
            //                     referralPriceDecimal:0.0000,
            //                     priceVisitorAccompany:0,
            //                     priceVisitorAccompanyDecimal:0.0000,
            //                     additionalFee2b:2000,
            //                     additionalFee2bDecimal:2000.0000,
            //                     additionalFee3b:1000,
            //                     additionalFee3bDecimal:1000.0000,
            //                     usageFeeType:1,
            //                     usageFee:0.0000,
            //                     usageFeeRate:0.000,
            //                     maxUsageFee:0.0000
            //                 }
            //             ],
            //             customerClassCode:0,
            //             isRequest:false,
            //             memberCode:"1000119000023115",
            //             reservationsDayInformationList:[
            //                 {
            //                     playDate:"2022-03-21T00:00:00",
            //                     remark:"",
            //                     ntgGeneralPurposeItem:
            //                         {
            //                             ResortTrustInfomation:{
            //                                 ownerMemberCode:"1000119000023115",
            //                                 hotelReservationNo:"0087500069",
            //                                 isDirectDebit:false
            //                             }
            //                         }
            //                 }
            //             ]
            //         }
            //     ],
            //     resultCode:0,
            //     error:null
            // };
            //afterConfirmHotelReservation(res)

export default GolfSearch;